
const ITEMS = [
  "Hajj Marketing",
  "Umrah Marketing",
  "Meta Ads",
  "Google Ads",
  "WhatsApp-First",
  "Lead Generation",
  "Email Nurture",
  "Built for India",
];

const Row = () => (
  <div className="flex items-center shrink-0">
    {ITEMS.map((item, i) => (
      <div key={i} className="flex items-center">
        <span
          className={`px-8 md:px-12 text-2xl md:text-4xl font-bold tracking-tight whitespace-nowrap ${
            i % 2 ? "text-outline" : "text-charcoal/85"
          }`}
        >
          {item}
        </span>
        <span className="h-2 w-2 rotate-45 bg-gold shrink-0" />
      </div>
    ))}
  </div>
);

export const Marquee = () => {
  return (
    <div
      className="overflow-hidden border-y border-charcoal/10 bg-cream py-5 md:py-6"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row />
      </div>
    </div>
  );
};
